import { render } from "./basicTable.vue?vue&type=template&id=055764db"
import script from "./basicTable.vue?vue&type=script&lang=js"
export * from "./basicTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__